var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg50({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.635735 32.5C0.635735 50.3743 15.1257 64.8643 33 64.8643C50.8743 64.8643 65.3643 50.3743 65.3643 32.5C65.3643 14.6257 50.8743 0.135742 33 0.135742C15.1257 0.135742 0.635735 14.6257 0.635735 32.5ZM51.7348 32.5C51.7348 42.8469 43.3469 51.2348 33 51.2348C22.6531 51.2348 14.2652 42.8469 14.2652 32.5C14.2652 22.1531 22.6531 13.7652 33 13.7652C43.3469 13.7652 51.7348 22.1531 51.7348 32.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0.135742C41.5835 0.135742 49.8155 3.54554 55.885 9.61501C61.9545 15.6845 65.3643 23.9165 65.3643 32.5C65.3643 41.0835 61.9545 49.3155 55.885 55.385C49.8155 61.4545 41.5835 64.8643 33 64.8643V51.2348C37.9688 51.2348 42.734 49.2609 46.2475 45.7475C49.7609 42.234 51.7348 37.4688 51.7348 32.5C51.7348 27.5312 49.7609 22.766 46.2475 19.2525C42.734 15.7391 37.9688 13.7652 33 13.7652V0.135742Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50);
export default __webpack_public_path__ + "static/media/50.6242cf5a89f497378396047985973e76.svg";
export { ForwardRef as ReactComponent };